import { Controller } from "@hotwired/stimulus"

// Adds another set of fields to a `fields_for` association — the one thing we
// used cocoon for.
//
//   <div data-controller="nested-form">
//     …existing fieldsets…
//     <template data-nested-form-target="template">
//       …one fieldset, rendered with child_index: "NEW_RECORD"…
//     </template>
//     <button data-action="nested-form#add" data-nested-form-target="anchor">Add</button>
//   </div>
//
// Removal is not handled here: both forms give each row a `_destroy` checkbox,
// which is what cocoon's remove link would have driven anyway.
//
// New fields are plain markup, so any Stimulus controller inside them connects
// on insertion by itself. cocoon needed a `cocoon:after-insert` hook to re-run
// select2 over the new row; there is nothing to re-run now.
export default class extends Controller {
    static targets = ["template", "anchor"]

    add(event) {
        event.preventDefault()

        // A timestamp keeps the new row's field names unique. Rails only needs
        // the index to differ from its siblings — it never round-trips.
        const markup = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
        this.anchorTarget.insertAdjacentHTML("beforebegin", markup)
    }
}
